import React, { Component } from 'react';
import Table5_8_1 from "./5-8-1";
import Table5_8_2 from "./5-8-2";
import "./index.scss";

export class index extends Component {
  render() {
    return (
      <div className="tb5_8">
        <div className="tb5_8-title">
          5.8 Chinese Restaurant Top 10 Favorite & Unpopular Dish Sales Summary 中餐厅菜品销售总结盘点
        </div>

        <Table5_8_1 {...this.props} />
        <Table5_8_2 {...this.props} />
      </div>
    )
  }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/5.0/5-8/index.js